/*
 * @Author: 赵泽文
 * @Date: 2022-04-27 11:20:47
 * @LastEditors: 赵泽文
 * @LastEditTime: 2022-04-27 15:21:51
 * @Description: 库存调整原因model
 */

import type {
  IAdjustmentReasonModel,
  IAdjustmentReasonStore,
} from '@monorepo/types/check/adjustmentReason/adjustmentReason.types';

const initState: IAdjustmentReasonStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 1000,
    page: 1,
  },
};

const adujustmentReasonStore: IAdjustmentReasonModel = {
  namespace: 'adjustmentReasonStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default adujustmentReasonStore;
